/**
 * PlayerHost — monta o player flutuante do LeadTalk/LeadMusic no AppShell, fora das
 * páginas, para o áudio seguir tocando em qualquer tela. Fecha pelo X ou quando o
 * painel sai (troca de conta, aviso de bloqueio).
 */
import { useEffect } from 'react';
import { AudioPlayer } from '../../components/contents/AudioPlayer';
import { usePlayerStore } from './playerStore';

export function PlayerHost(): JSX.Element | null {
  const open = usePlayerStore((s) => s.ctx !== null);
  const close = usePlayerStore((s) => s.close);

  // Sem o painel, o áudio não pode voltar a tocar sozinho quando ele remontar.
  useEffect(() => () => close(), [close]);

  return open ? <AudioPlayer /> : null;
}
